import React from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom'; 
  
const Footer = () => { 
  const currentYear = new Date().getFullYear(); 
    return (
        <>
        
            <div className='footer multbg'>
                 <div className='container-fluid'>
                  <div className='row'>
                    <div className='col-md-6 col-lg-3'>
                      <div className='ftr-logo'>
                          <Link to="/"><LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/ftr-logo.png" alt="St. Francis Xavier School" className='img-fluid' /></LazyLoad></Link>
                       
                      </div>
                    </div>  
                    <div className='col-md-6 col-lg-2'>
                      <div className='title'>
                        <h2>Quick Links</h2>
                      </div>
                      <ul>
                        <li><Link to="https://portalguidelines.campuscare.info/index.html#SFXSCH" target="_blank"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/icon-list.png" alt="St. Francis Xavier School"></img> Portal Help?</Link></li>
                        <li><Link to="/ErpSoftware"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/icon-list.png" alt="St. Francis Xavier School"></img> ERP Software</Link></li>
                        <li><Link to="/Academics"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/icon-list.png" alt="St. Francis Xavier School"></img> Academics</Link></li>
                        <li><Link to="/Tc"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/icon-list.png" alt="St. Francis Xavier School"></img> TC Issued</Link></li>
                        <li><Link to="/MailUs"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/icon-list.png" alt="St. Francis Xavier School"></img> Mail Us</Link></li> 
                      </ul>
                      </div>  
                      <div className='col-md-6 col-lg-3'>
                        <div className='title'>
                          <h2>Keep in Touch</h2>
                        </div>
                        <p><i class="bi bi-geo-alt-fill"></i> <Link to="https://maps.app.goo.gl/yvq7PQrtP4vwxahV9" target="_blank"> Talwandi Rana, Hisar, Haryana 125001 </Link></p>
                        <p><i class="bi bi-telephone-fill"></i> <Link to="tel:+91-9813186557">+91-9813186557</Link>, <Link to="tel:+91-9588354763">+91-9588354763</Link></p>
                        <p><i class="bi bi-envelope-fill"></i> <Link to="mailto: sfxhsr@yahoo.com">sfxhsr@yahoo.com</Link></p>
                      </div>                 
                    <div className='col-md-6 col-lg-4'>
                      <div className="mobile-app">
                        <div>
                          <h3>Download Mobile App</h3>
                          <p>  CampusCare 10x mobile app for parents is a tool that serves as a single point of reference for parents. The app centralises all the school-parent interaction and lets parents stay updated with their ward's day-to-day activities. Parents can receive assignments, homework, and circulars, keep track of their child's attendance, do online fee payment, view report cards.</p>
                          <div className='mobile-link'>
                            <Link to="https://apps.apple.com/in/app/campuscare-10x/id1611283814" target='_blank'><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/app-store.png" alt="St. Francis Xavier School" /></LazyLoad></Link>
                            <Link to="https://play.google.com/store/apps/details?id=com.entab.learninglab&hl=en-IN" target='_blank'><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/playstore1.png" alt="St. Francis Xavier School" /></LazyLoad></Link>
                          </div>
                          <p className='code'><Link to="https://entab.online/SFXSCH" target="_blank">SFXSCH</Link></p>
                        </div>
                        <div>
                         <LazyLoad> <img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/mobile.png' alt="St. Francis Xavier School" className='footer-mobile' /></LazyLoad>
                        </div>
                      </div>
                    </div>
                  </div>
                 </div>
                 <div className='copyright'>
            ©️ {currentYear} All Copyright Reserved St. Francis Xavier School, Hisar. Designed and Developed by<Link to="https://entab.in" target="_blank"> Entab Infotech : CampusCare®️</Link>  
            </div>
            </div>
            
        </>
    );
}

export default Footer;
